import React from 'react';
import { useSession } from 'src/app/hooks/useSession';
import { AdminMetrics } from './AdminMetrics';
import { ExamsMetricsUser } from './exams-metrics-user';

export function ExamMetrics() {
  const { session } = useSession();

  const sessionUser = session.user.profileNames[0];

  return sessionUser === 'Aluno' ? <ExamsMetricsUser /> : <AdminMetrics />;
}
